import { getLoggerInstance } from '@idmc-ms-fabric/common';
import Logger, { BasePublisher } from '@idmc-ms-fabric/common/src/Logger/Logger';
import { createContext, FC, useCallback, useContext, useEffect, useState } from 'react';

import { IDQALoggerState, LoggerInstance } from './IDQALogger.types';
const PUBLISHER_PREFIX = 'IDQA';

const initState: IDQALoggerState = {
	config: {
		prefix: PUBLISHER_PREFIX,
	},
	addPublisher: (publisher: BasePublisher) => {},
	logger: getLoggerInstance({ prefix: PUBLISHER_PREFIX }),
};
const Context = createContext<IDQALoggerState>(initState);
export const useIDQALoggerContext = (): IDQALoggerState => useContext(Context);

const IDQALoggerContext: FC = ({ children }) => {
	const [loggerInstance] = useState<LoggerInstance>(initState.logger);

	const addPublisher = useCallback(() => loggerInstance && loggerInstance.addPublisher, [loggerInstance]);

	const init = () => {
		Logger.setPublisherPrefix(PUBLISHER_PREFIX);
		window.fabric_data_quality = {
			locale: {
				enablePseudoLocale: () => {},
				disablePseudoLocale: () => {},
			},
			downloadLogs: (fileName: string) => Logger.downloadLogs(fileName),
		};
	};

	useEffect(() => {
		init();
	}, []);
	return <Context.Provider value={{ logger: loggerInstance, addPublisher, config: { ...initState.config } }}>{children}</Context.Provider>;
};

export default IDQALoggerContext;
